import React from "react"
import { ErrorMsgSpan, InputText, TextInputContainer } from "./style"

function TextInput({ name, type = "text", id, onChange, label, mt = "", labelColor="", width = "100%", error, visible, ErrorMt, ...rest }) {
	return (
		<TextInputContainer mt={mt} width={width} labelColor={labelColor}>
			<label htmlFor={name}>{label}</label>
			<InputText type={type} name={name} id={id} onChange={onChange} {...rest} />
			{visible && error ? <ErrorMsgSpan ErrorMt={`${mt}`}>{error}</ErrorMsgSpan> : null}
		</TextInputContainer>
	)
}
export function InputField({ name, type = "text", id, onChange, label, error, visible, ErrorMt, ...rest }) {
	return (
		<div>
			<label className="block mb-1 font-medium" htmlFor={name}>{label}</label>
			<input type={type} name={name} id={id} className="px-4 w-full py-2 rounded-lg border" onChange={onChange} {...rest} />
			{visible && error ? <p className="text-red-500 text-sm">{error}</p> : null}
		</div>
	)
}

export default TextInput
